<script lang="ts" setup>
import { AppUserType } from '~/enums/permissions/_types';
const { can } = usePermissions();
</script>
<template>
    <q-footer bordered class="bg-on-background text-background q-px-md">
        <div class="row items-center justify-between q-py-sm page-container">
            <div class="text-weight-bold">{{ $t('app.short-name') }}</div>
            <div class="row" v-if="can(AppUserType.Admin, AppUserType.Dealer)">
                <link-btn
                    :href="`mailto:${$t('app.email')}`"
                    active-color="background"
                    text-color="background"
                    class="q-pa-none a-text-14"
                >
                    <q-icon size="sm" name="las la-envelope" class="q-mr-sm" />
                    <span class="footer-link-btn">{{ $t('app.email') }}</span>
                </link-btn>
                <link-btn
                    :href="`tel:${$t('app.phone').replace(/\s/g, '')}`"
                    active-color="background"
                    text-color="background"
                    class="q-pa-none a-text-14 q-ml-xl"
                >
                    <q-icon size="sm" name="las la-phone" class="q-mr-sm" />
                    <span class="footer-link-btn">{{ $t('app.phone') }}</span>
                </link-btn>
            </div>
        </div>
    </q-footer>
</template>

<style lang="scss">
.footer-link-btn {
    text-decoration: underline;
    text-underline-offset: 3px;
}
</style>
